import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
} from '@angular/core';
import { InputDirective } from '../directives/input.directive';
import { FormFieldLabelComponent } from '../form-field-label/form-field-label.component';

@Component({
  selector: 'shabic-checkbox-control',
  templateUrl: './checkbox-control.component.html',
  styleUrls: ['./checkbox-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxControlComponent {
  @ContentChild(InputDirective) input?: InputDirective;
  @ContentChild(FormFieldLabelComponent) label?: FormFieldLabelComponent;

  onToggle(): void {
    this.input?.click();
  }
}
